import NewReleases from "@mui/icons-material/NewReleases";
import { Button } from "@mui/material";
import { useFlag } from "../../../../../server/optimizely";

import type { FC } from "react";

export const WhatsNew: FC = () => {
  const [productPortal] = useFlag("product_portal");
  return (
    <Button
      size="small"
      sx={{ color: "text.sidebar", p: 0 }}
      data-analytics-id="sidebar-whats-new"
      variant="text"
      startIcon={<NewReleases />}
      href={
        productPortal
          ? "/product-portal"
          : "https://help.changeengine.com/articles/2026-product-updates-yeFMukDi6a"
      }
      target="_blank"
    >
      What’s new?
    </Button>
  );
};
